export default axios => ({
  send(session_id, payload) {
    return axios.patch(`/session/${session_id}/user/update`, payload);
  },
  getGender() {
    return axios.get('/compendium/gender')
  }
})